import { SELECT_PLAYERS, UPDATE_DOTS, RESTART, SET_OPTIONS } from './actions';
import { SET_CURRENT_PLAYER, SET_PLAYER_TO_START, UPDATE_CURRENT_TIME, SET_OPTION } from './actions';
import { UPDATE_LINES, UPDATE_HINTS, UPDATE_SHAPES, UPDATE_STATS, SET_FROM_TO } from './actions';
import { START_PLAYBACK, STOP_PLAYBACK, PAUSE_PLAYBACK, SELECT_SIZE, SELECT_SKILL } from './actions';
import { PLAYER1, ALTERNATE, PLAYER2, OPTIONS_KEY } from '../const';
import * as f from '../logic';
import _ from 'lodash';
import { dbset, dbdel } from '../../HOME/utils';

export default (state = {}, action) => {
  switch (action.type) {
    case SELECT_PLAYERS:
      return { ...state, players: action.players };
    case UPDATE_DOTS:
      return { ...state, dots: action.dots };
    case UPDATE_LINES:
      return { ...state, lines: action.lines };
    case UPDATE_HINTS:
      return { ...state, hints: action.hints };
    case UPDATE_SHAPES:
      return { ...state, shapes: action.shapes };
    case SET_CURRENT_PLAYER:
      return { ...state, currentPlayer: action.player };
    case SET_PLAYER_TO_START:
      return f.gameStarted(state) ? state : onRestart(state, null, action.player);
    case RESTART:
      return onRestart(state, action);
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case UPDATE_CURRENT_TIME:
      return { ...state, currentTime: action.time };
    case SET_OPTIONS:
      return { ...state, options: action.options || {} };
    case SET_OPTION:
      let options = state.options || {};
      options = { ...options, [action.payload.name]: action.payload.value };
      dbset(OPTIONS_KEY, options);
      return { ...state, options };
    case SET_FROM_TO:
      return { ...state, from: action.payload.from, to: action.payload.to };
    case START_PLAYBACK:
      return onStartPlayback(state);
    case STOP_PLAYBACK:
      return { ...state, playback: false, playbackLines: [] };
    case PAUSE_PLAYBACK:
      return { ...state, playbackPaused: !action.resume };
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case SELECT_SKILL:
      return { ...state, skill: action.skill };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    return { ...state, stats: { wins1: 0, plays: 0, ave: 0, best: 0, wins2: 0, grade: 0 } };
  }

  const { plays, best, ave, grade } = f.getMoreStats(stats, state.size);
  return { ...state, stats: { wins1: stats.wins1, plays, best, ave, wins2: stats.wins2, grade } };
}

function onRestart(state, action, player) {
  _.each(state.dots, d => {
    f.restoreVisibility(d);
  });

  const { whoStarted } = state;
  const whoStarts = state.options.whoStarts;

  if (action) {
    player = whoStarts;

    if (whoStarts === ALTERNATE) {
      player = action.initial ? PLAYER1 : whoStarted === PLAYER1 ? PLAYER2 : PLAYER1;
    }

    player = player || PLAYER1;
  }

  const cleanState = {
    ...state,
    playback: false,
    playbackLines: [],
    lines: [],
    hints: [],
    from: undefined,
    to: undefined,
    shapes: [],
    whoStarted: player,
    currentPlayer: player,
  };

  dbset(f.boardKey(state), f.toJson(cleanState));

  return cleanState;
}

function onStartPlayback(state) {
  _.each(state.dots, d => {
    f.restoreVisibility(d);
  });

  return {
    ...state,
    playback: true,
    playbackLines: _.clone(state.lines),
    lines: [],
    hints: [],
    from: undefined,
    to: undefined,
    shapes: [],
    currentPlayer: state.whoStarted,
  };
}
